import { FullDate } from '@/Domain/Date'

export class DogaDate extends FullDate {}
